<div class="flex flex-col">
  <div class="flex top bg-white border-bottom w-full h-18 justify-between">
    <nav class="bg-white z-30 flex-1 inline-flex w-auto max-w-[1500px] text-md mx-auto py-1">
      <div class="flex flex-1 items-center justify-start h-16">
        <a class="text-xl font-bold flex items-center ml-3 flex-none text-center">
          <img
            src="https://brainnet-cdn-ep-content.azureedge.net/logo-magnit_mark-only_204x270.svg"
            class="h-12 w-12 mr-4 m-auto"
            alt="Magnit Global Logo"
          />
        </a>
      </div>
      <div class="flex flex-1 items-center justify-end h-16"><app-date-label></app-date-label></div>
    </nav>
  </div>
</div>
<div class="section bg-white">
  <app-return-bar
    text="{{ 'edit-subscription-notifications.title' | translate }}"
    [showReturnIcon]="false"
  ></app-return-bar>
  <div class="my-4 bg-white accordion-mobile">
    <div class="container-lg container-hide-padding-mobile">
      <div class="card content-wrapper">
        <div class="card-header px-4 py-3 bg-blue d-flex align-items-center content-header">
          <h2 class="mb-0 pt-0 flex-grow-1">
            {{ 'edit-subscription-notifications.title' | translate }}
          </h2>
        </div>
        <div class="card-body py-4 content-body">
          <div class="row no-gutters d-flex justify-center">
            <div class="col-12 col-md-8">
              @if (view() === 'form') {
                <form>
                  <div class="tab-content py-2 md:pl-4">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="textblock" style="max-width: 1000px">
                          <div class="mb-5">
                            <div class="align-items-center mb-5">
                              <h2 class="mb-0">
                                <strong>{{ 'edit-subscription-notifications.header' | translate }}</strong>
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="textblock" style="max-width: 1000px">
                          <div class="mb-5">
                            <div class="align-items-center mb-5">
                              <p class="mb-5">
                                {{ 'edit-subscription-notifications.text' | translate }}
                              </p>
                              <p>
                                {{ 'edit-subscription-notifications.subheader' | translate }}
                                <strong class="mt-5">{{ emailAddress() }}</strong>
                              </p>
                              @if (receivingEmails() !== null) {
                                <p>
                                  {{ 'edit-subscription-notifications.current-state-label' | translate }}
                                  <strong>
                                    @if (receivingEmails()) {
                                      {{ 'edit-subscription-notifications.current-state-receiving' | translate }}
                                    } @else {
                                      {{ 'edit-subscription-notifications.current-state-not-receiving' | translate }}
                                    }
                                  </strong>
                                </p>
                              }
                            </div>
                            <div class="row clearfix">
                              <div class="col-sm-12">
                                <div class="mb-3 text-gray-dark">
                                  <strong>{{ 'edit-subscription-notifications.question' | translate }}</strong>
                                </div>
                                <app-choices #notificationPreferenceChoices [(value)]="keepReceiving">
                                  <app-choice
                                    key="true"
                                    [display]="'edit-subscription-notifications.yes-option' | translate"
                                  >
                                  </app-choice>
                                  <app-choice
                                    key="false"
                                    [display]="'edit-subscription-notifications.no-option' | translate"
                                  >
                                  </app-choice>
                                </app-choices>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="float-sm-right">
                              <button
                                type="button"
                                class="btn btn-primary min-w-100 mr-1 mb-2 float-right btn-stretch-on-mobile"
                                [disabled]="saving()"
                                (click)="save()"
                              >
                                {{ 'edit-subscription-notifications.save' | translate }}
                              </button>
                              <button
                                type="button"
                                class="btn btn-outline-primary min-w-100 mr-1 mb-2 float-right btn-stretch-on-mobile"
                                [disabled]="saving()"
                                (click)="cancel()"
                              >
                                {{ 'edit-subscription-notifications.cancel' | translate }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              } @else {
                <div class="tab-content py-2 md:pl-4">
                  <div class="textblock" style="max-width: 1000px">
                    <div class="mb-5">
                      <h2 class="mb-4">
                        <strong>{{ 'edit-subscription-notifications.confirmation-title' | translate }}</strong>
                      </h2>
                      <ul>
                        <li>
                          @if (confirmationMode() === 'subscribed') {
                            {{
                              'edit-subscription-notifications.confirmation-subscribed'
                                | translate: { email: emailAddress() }
                            }}
                          } @else {
                            {{
                              'edit-subscription-notifications.confirmation-unsubscribed'
                                | translate: { email: emailAddress() }
                            }}
                          }
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
